import { keepPreviousData, useQuery } from '@tanstack/react-query';
import { EmployeeTimeOffResponse } from '../../../types/EmployeeTimeOff';
import CustomAxios from '../../../utility/customAxios';
import { queryKeys } from '../queryKeys';

export type EmployeeTimeOffStatus = 'active' | 'past';
export type EmployeeTimeOffFilterParam = {
  employee_uuid?: string[];
  status?: EmployeeTimeOffStatus;
};

export type EmployeeTimeOffSortableColumns = 'start_date' | 'end_date' | 'mode';
export type EmployeeTimeOffSortParam = {
  [K in EmployeeTimeOffSortableColumns]?: -1 | 1;
};

export type UseGetAllEmployeeTimeOffsParams = {
  page?: number;
  per_page?: number;
  filters?: EmployeeTimeOffFilterParam;
  sort?: EmployeeTimeOffSortParam;
};

export type UseGetAllEmployeeTimeOffsProps = {
  params?: UseGetAllEmployeeTimeOffsParams;
  enabled?: boolean;
};

export const fetchAllEmployeeTimeOffs = async ({ params }: UseGetAllEmployeeTimeOffsProps) => {
  const response = await CustomAxios.get<EmployeeTimeOffResponse>('employee_time_offs', { params });

  return response.data;
};

export function useGetAllEmployeeTimeOffs({ params, enabled = true }: UseGetAllEmployeeTimeOffsProps) {
  return useQuery({
    enabled,
    queryKey: [queryKeys.allEmployeeTimeOffs, params],
    queryFn: () => fetchAllEmployeeTimeOffs({ params }),
    placeholderData: keepPreviousData,
  });
}
